import { DataLoader } from 'src/app/services/data-loader/data-loader';

type MonthlyDataPoint = {
    date: string;
    mau: number;
    new_users: number;
    dates: number;
    avg_monthly_dau: number;
};

const MS_IN_DAY = 24 * 60 * 60 * 1000;

const parseIsoDate = (value: string | Date): Date => {
    if (value instanceof Date) {
        return new Date(
            Date.UTC(
                value.getUTCFullYear(),
                value.getUTCMonth(),
                value.getUTCDate()
            )
        );
    }

    const [year, month, day] = value.split('-').map(Number);
    return new Date(Date.UTC(year, month - 1, day));
};

const formatIsoDate = (date: Date): string => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const buildMockMonthlyData = (
    monthStart: Date,
    dates: number
): MonthlyDataPoint => {
    const month = monthStart.getUTCMonth() + 1;
    const year = monthStart.getUTCFullYear();
    const seasonFactor = 1 + (month % 4) * 0.06;
    const yearFactor = 1 + (year - 2025) * 0.04;

    const mau = Math.round(620000 * seasonFactor * yearFactor);
    const newUsers = Math.round(mau * (0.3 + (month % 3) * 0.05));
    const avgMonthlyDau = Number(
        (mau * (0.24 + (month % 5) * 0.01)).toFixed(6)
    );

    return {
        date: formatIsoDate(monthStart),
        mau,
        new_users: newUsers,
        dates,
        avg_monthly_dau: avgMonthlyDau,
    };
};

export const generateMonthlyDates = (
    startDate: string | Date,
    endDate: string | Date
): MonthlyDataPoint[] => {
    const start = parseIsoDate(startDate);
    const end = parseIsoDate(endDate);

    if (end < start) {
        return [];
    }

    const result: MonthlyDataPoint[] = [];
    let cursor = new Date(
        Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), 1)
    );

    while (cursor <= end) {
        const monthStart = new Date(
            Date.UTC(cursor.getUTCFullYear(), cursor.getUTCMonth(), 1)
        );
        const monthEnd = new Date(
            Date.UTC(cursor.getUTCFullYear(), cursor.getUTCMonth() + 1, 0)
        );

        const effectiveStart = start > monthStart ? start : monthStart;
        const effectiveEnd = end < monthEnd ? end : monthEnd;
        const daysInRange =
            Math.floor(
                (effectiveEnd.getTime() - effectiveStart.getTime()) / MS_IN_DAY
            ) + 1;

        if (daysInRange > 0) {
            result.push(buildMockMonthlyData(monthStart, daysInRange));
        }

        cursor = new Date(
            Date.UTC(cursor.getUTCFullYear(), cursor.getUTCMonth() + 1, 1)
        );
    }

    return result;
};

export const createCase9 = () => {
    return new DataLoader('', async function (queryContext, cancellationToken) {
        // wait
        await new Promise((resolve) => setTimeout(resolve, 1000));

        this.emitter.emit({
            data: generateMonthlyDates('2019-07-01', '2025-09-18'),
            queryContext: { datasourceColumns: [], settings: {} },
            status: 'ok',
            statusMessage: '',
            isLoading: false,
            sqlAndJsProcessing: '',
        });
    });
};
